import moment from "moment";
import { isNullOrEmpty } from '../config/ENV';

export function getDateDifference (startDate, endDate)  {
  var sDate = moment(startDate);
  if (endDate == 0 || isNullOrEmpty(endDate)) {
    endDate = new Date()
    // return "Curently working";
  }
  // if(startDate ==0 ||  isNullOrEmpty(endDate)){
  //   return "Curently working";
  // }
  // if(startDate==endDate){
  //   startDate=new Date();
  // }
  var eDate = moment(endDate);

  var years = eDate.diff(sDate, "years");
  var months = eDate.diff(sDate, "months") % 12;
  var days = eDate.diff(sDate, 'days');

  var duration = "";
  if (years == 1) duration = years + " Year ";
  if (years > 1) duration = years + " Years ";
  // if(years == 0) duration = years + " Years ";
  // if(years<1) duration =  " Less than a month ";

  if (months == 1) duration = duration + months + " Month";
  if (months > 1) duration = duration + months + " Months";
  if(months == 0 && years == 0) duration =  " Less than a month"; 
  // if(months == 0) duration =duration + months + + " Months ";

  return duration;
};
